import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message", "timer"]
  static values = { duration: Number }

  connect() {
    if (this.hasTimerTarget) {
      this.timerTarget.style.setProperty("--toast-duration", `${this.durationValue}ms`)
    }

    requestAnimationFrame(() => this.element.classList.add("c-toast--visible"))
  }

  // Dismissal rides on the timer bar's animation, so pausing that animation on hover pauses dismissal too.
  expire(event) {
    if (this.hasTimerTarget && event.target === this.timerTarget) this.dismiss()
  }

  dismiss() {
    if (this.element.classList.contains("c-toast--leaving")) return

    this.element.classList.add("c-toast--leaving")
    this.element.addEventListener("transitionend", (event) => {
      if (event.target === this.element) this.element.remove()
    })
  }
}
